import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { PatternFormat } from 'react-number-format';
import { Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import OutsideClickHandler from 'react-outside-click-handler';
import Loading from '../Loading/Loading';
import InfiniteScroll from 'react-infinite-scroll-component';
export default function SearchInput({ placeholder = 'Введите строку для поиска', optionName, error, disabled, rules = { required: { value: true, message: '*Обязательное поле для заполнения' } }, form, name, type, className, onSearch = () => {}, sliceName, actionName, classNameWrap }) {
  const errorForm = form?.formState?.errors?.[name];
  console.log(error);
  console.log(rules);
  const disaptch = useDispatch();

  const [searchText, setSearchText] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const page = useRef(1);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (type == 'search-select') {
      setLoading(true);
      page.current = 1;
      const sendSearchRequest = setTimeout(() => {
        // if (searchText && searchText.length) {
        setSearchData([]);
        setLoading(false);
        onSearch(searchText, page.current);
        // dispatch(sendRequestToSaga(searchText));
        // }
      }, 600);
      return () => clearTimeout(sendSearchRequest);
    }
  }, [searchText]);
  const selector = useSelector((state) => state[sliceName]);
  const selectorData = selector[actionName];
  const [searchData, setSearchData] = useState([]);
  useEffect(() => {
    if (selectorData.data) {
      setSearchData((prev) => [...prev, ...selectorData.data.results]);
    }
  }, [selectorData.data]);

  const watchValue = form.watch(name);

  React.useEffect(() => {
    const subscription = form.watch((value, { name: formName, type }) => {
      if (name == formName) {
        form.trigger(name);
      }
    });
    return () => subscription.unsubscribe();
  }, [form.watch]);

  return (
    <>
      <div className={clsx('relative ')}>
        <OutsideClickHandler
          onOutsideClick={() => {
            setSearchText('');
            setShowSearch(false);
          }}>
          <input
            onFocus={() => {
              setShowSearch(true);
            }}
            class={clsx(
              `w-full block w-full rounded-md border border-1 border-gray-300 focus:border-button px-3.5 py-2 text-gray-900 shadow-sm   placeholder:text-gray-400  focus:outline-none sm:text-sm sm:leading-6 pr-8`,
              className,
              (errorForm || error) && 'border-red-300 focus:border-red-500 placeholder:text-red-400',
            )}
            disabled={disabled}
            autoComplete="off"
            data-1p-ignore
            data-lpignore="true"
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
            placeholder={watchValue && !showSearch ? '' : placeholder}
          />
          {watchValue && !showSearch && <div className="absolute top-[50%] -translate-y-1/2 text-sm  select-none cursor-pointer text-[#069488] bg-[rgb(6,148,136,0.1)] font-semibold px-2 py-1  rounded-md left-2 pointer-events-none select-none">{watchValue.label}</div>}
          {showSearch ? (
            <>
              {(selectorData.loading || loading) && page.current == 1 ? <></> : selectorData?.data?.count == 0 && page.current == 1 ? <></> : <div className="absolute text-xs text-gray-500 top-[103%] left-0 pl-2 bg-[#fff] w-[100%]">Найдено: {selectorData?.data?.count}</div>}

              <div className="absolute top-[150%] left-0 bottom-0 block w-full rounded-md border border-1 border-gray-300 h-[163.2px] bg-white p-2  text-gray-600 text-opacity-80 z-[100000] overflow-y-auto" id="search-list">
                {(selectorData.loading || loading) && page.current == 1 ? (
                  <div className="">
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-[100%] -translate-y-1/2 font-semibold ">Поиск </div>
                    <Loading className="absolute top-1/2 left-1/2 transform -translate-x-[15%] -translate-y-1/2 scale-75" />
                  </div>
                ) : selectorData?.data?.count == 0 && page.current == 1 ? (
                  <>
                    <div className="">
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 font-semibold ">Ничего не найдено </div>
                    </div>
                  </>
                ) : (
                  <>
                    <InfiniteScroll
                      dataLength={searchData.length}
                      next={() => {
                        if (selectorData?.data?.next) {
                          page.current += 1;
                          onSearch(searchText, page.current);
                        }
                      }}
                      hasMore={true}
                      scrollableTarget="search-list">
                      {searchData?.map((item) => (
                        <div
                          onClick={() => {
                            form.setValue(name, { label: item[optionName], value: item.id, type: item?.type, role: item?.role, employerId: item?.employer?.id });
                            setSearchText('');
                            setShowSearch(false);
                          }}
                          className="text-sm  select-none cursor-pointer hover:text-[#069488] hover:bg-[rgb(6,148,136,0.1)] font-semibold p-2 rounded-md">
                          {item[optionName]}
                        </div>
                      ))}
                    </InfiniteScroll>
                  </>
                )}
              </div>
            </>
          ) : (
            <></>
          )}
          <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 24 24" className="text-gray-700 absolute top-[50%] -translate-y-[50%] right-[14px]">
            <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314"></path>
          </svg>
        </OutsideClickHandler>
      </div>
    </>
  );
}
